var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBasicDetails(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.001,
    height: 26,
    viewBox: "0 0 26.001 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3755",
    "data-name": "Group 3755",
    transform: "translate(-16913 420)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13205",
    "data-name": "Path 13205",
    d: "M8.133,0H0",
    transform: "translate(16929.867 -412.569)",
    fill: "none",
    stroke: "#3d7dc9",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13207",
    "data-name": "Path 13207",
    d: "M3.479,0H0",
    transform: "translate(16929.867 -419)",
    fill: "none",
    stroke: "#3d7dc9",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13210",
    "data-name": "Path 13210",
    d: "M20.934,22.334V19.889A5.116,5.116,0,0,0,15.618,15h-9.3A5.116,5.116,0,0,0,1,19.889v2.445",
    transform: "translate(16913 -417.334)",
    fill: "none",
    stroke: "#3d7dc9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_418",
    "data-name": "Ellipse 418",
    cx: 4.324,
    cy: 4.37,
    rx: 4.324,
    ry: 4.37,
    transform: "translate(16919.297 -414.876)",
    fill: "none",
    stroke: "#3d7dc9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13211",
    "data-name": "Path 13211",
    d: "M5.84,0H0",
    transform: "translate(16929.867 -415.785)",
    fill: "none",
    stroke: "#3d7dc9",
    strokeLinecap: "round",
    strokeWidth: 2
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasicDetails);
export default __webpack_public_path__ + "static/media/BasicDetails.bb865a1b317658fda70e3c434109251e.svg";
export { ForwardRef as ReactComponent };